import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';
import { nike } from '@nike/nike-design-tokens';

const Currency = ({ value, type, error }) => {
  // The number 0 returns a falsy value, but we still want to render it.
  if (typeof value !== 'number' && !value) return null;
  return (
    <span
      data-desc='currency'
      data-currency-value={value}
      data-currency-type={type}
      style={{ color: error ? nike.podiumCdsColorRed500 : '' }}
    >
      <FormattedNumber
        value={value}
        style='currency' /* eslint-disable-line react/style-prop-object */
        currency={type}
        minimumFractionDigits={value % 1 === 0 ? 0 : 2}
        maximumFractionDigits={value % 1 === 0 ? 0 : 2}
      />
    </span>
  );
};

Currency.defaultProps = {
  value: null,
  error: false
};

Currency.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string.isRequired,
  error: PropTypes.bool
};

export default Currency;
